const dom = {
	mq: {
		mobile: 700,
		tabletV: 850,
		tablet: 1050,
		laptop: 1400
	}
}

export {dom};